import UserCurrent from '@/components/admin/users/UserCurrent'
import UserCurrentNotifications from '@/components/admin/users/UserCurrentNotifications'
import auth from './../auth'

export default [
  {
    path: '/admin/me/notifications',
    name: 'UserCurrentNotifications',
    component: UserCurrentNotifications,
    beforeEnter: auth.ifAuthenticated
  },
  {
    path: '/admin/me',
    name: 'UserCurrent',
    component: UserCurrent,
    beforeEnter: auth.ifAuthenticated
  }
]
